// extracted by mini-css-extract-plugin
module.exports = {"contactPrezzee":"styles_contactPrezzee__tGCCY"};